import React, { useEffect } from "react"
import GenralInformation from "./GenralInformation";
import css from './ListingPage.module.css';
import PeopleDetails from "./PeopleDetails";
import BusinessPerformance from "./BusinessPerformance";
import AssetsDetails from "./AssetsDetails";
import Liabilities from "./Liabilities";
import SellingConditions from "./SellingConditions";
import { useDispatch } from "react-redux";
import { viewListing } from "../SearchPage/SearchPage.duck";
import { useIntl } from "react-intl";
import { formatCurrency, getcurrencySymbol } from "../SubscriptionPlans/SubscriptionHelpers";
import classNames from "classnames";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import SectionTextMaybe from "./SectionTextMaybe";

const CustomListingDetails = ({ id, currentListing }) => {
    const dispatch = useDispatch();


    const viewListingData = async () => {
        await dispatch(viewListing(id))
            .then((res) => {
                console.log(res, 'view----')
            });
    }

    useEffect(() => {
        viewListingData(id)
    }, [id])

    const address = currentListing?.attributes?.publicData?.location?.address?.split(",");
    const publicData = currentListing?.attributes?.publicData;
    const highlights = publicData?.highlightKeys ? JSON.parse(publicData?.highlightKeys) : []

    const intl = useIntl()
      const location = useLocation();
    
    const params = new URLSearchParams(location.search);
    const local = params.get("local")
    return <div className={css.priceListing}>
        <div className={css.mainDetails}>
            <div className={css.shopInformation}>
                <div className={css.shopCard}>
                    <div className={css.shopCardHeading}>{intl.formatMessage({ id: 'Listing.customDetails.Price' })}</div>
                    <div className={classNames(css.shopCardVal,local === "de" ? css.priceValueeuro : css.priceValuedoller)}>{formatCurrency(currentListing?.attributes?.price?.amount)}</div>
                </div>
                <div className={css.shopCard}>
                    <div className={css.shopCardHeading}>{intl.formatMessage({ id: 'Listing.customDetails.Location' })} </div>
                    <div className={css.shopCardVal}>{address?.[address?.length - 1]}</div>
                </div>
                <div className={css.shopCard}>
                    <div className={css.shopCardHeading}>{intl.formatMessage({ id: 'Listing.customDetails.Monthlyturnover' })}</div>
                    <div className={classNames(css.shopCardVal,local === "de" ? css.priceValueeuro : css.priceValuedoller)}>{formatCurrency(publicData?.Monthly_turn_over*100)}</div>
                </div>
                <div className={css.shopCard}>
                    <div className={css.shopCardHeading}>{intl.formatMessage({ id: 'Listing.customDetails.Owners' })}</div>
                    <div className={css.shopCardVal}>{publicData?.Owners}</div>
                </div>
            </div>


        </div>

        <div className={css.keyDetails}>
            <h2>{intl.formatMessage({ id: 'Listing.customDetails.Keydetails' })}:</h2>
            <div className={css.keyLists}>
                <SectionTextMaybe text={currentListing?.attributes?.description}/>
            </div>
        </div>

        <GenralInformation publicData={publicData} />
        <PeopleDetails publicData={publicData} />
        <BusinessPerformance listing={currentListing} publicData={publicData} />
        <AssetsDetails publicData={publicData} />
        <Liabilities publicData={publicData} />
        <SellingConditions publicData={publicData} />

        <div className={css.heighlight}>
            {
                highlights?.map((highlight) => {
                    return (
                        <span>{highlight} </span>
                    )
                })
            }
            <div className={css.clearfix}></div>

        </div>
    </div>
}

export default CustomListingDetails;